export default "__VITE_ASSET__DVghVmxc__"